'use strict';

import Api from "./Api";

export default class DirectionShow extends Api {

    static getList(page = 1, perPage = 10) {
        const url = this.url + 'direction/show-list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
            },
        });
    }

    static get(id) {
        const url = this.url + 'direction/show-get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'direction/show-add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'direction/show-update';

        return this.getAxios().post(url, data);
    }

}